import { chainConfig, ethereumFacts } from '@morpho-org/viem-dlc/chains'
import { defineChain as viemDefineChain } from 'viem'
import { optimism as viemOptimism } from 'viem/chains'

import type { AppChain } from './chain.types'

export const optimism = viemDefineChain({ ...viemOptimism, ...chainConfig }).extend({
  viemDlc: ethereumFacts,
  custom: {
    name: 'Optimism Mainnet',
    shortName: 'Optimism',
    safeShortName: 'oeth',
    morphoChainSlug: 'opmainnet',
    defiLlamaSlug: 'optimism',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://optimistic.etherscan.io', name: 'Optimistic Etherscan' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x8cD70A8F399428456b29546BC5dBe10ab6a06ef6',
          startBlock: 130770075n
        },
        MorphoBlue: {
          address: '0xce95AfbB8EA029495c66020883F87aaE8864AF92',
          startBlock: 130770075n
        },
        MetaMorphoV11Factory: {
          address: '0x3Bb6A6A0Bc85b367EFE0A5bAc81c5E52C892839a',
          startBlock: 130770189n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0x6128b680b277Bf4Df80DFE9D8c55A498660870ef',
          startBlock: 142122059n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0x65956d5Ba4974983ecCe111612FC0A0c22650A11',
          startBlock: 142122059n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x71B299bDb52b6396429cd1E11c418324502CB434',
          startBlock: 144881071n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xEe9F7C64dD827ED7b5CAA2272936366FAca00CF3',
          startBlock: 142122059n
        },
        RegistryList: {
          address: '0xD1346be260cd22Eab9E6163010b0D5CbfAAAD32b',
          startBlock: 142122170n
        },
        BluePublicAllocator: {
          address: '0xc6945A915Bb7e2A365469f120A33D2FA42951cF3',
          startBlock: 155659263n
        }
      }
    }
  }
}) satisfies AppChain<{ v1: true; v2: true }>
